






import { Component, Vue } from "vue-property-decorator";
import ProfileSecurityComponent from "@/app/components/profile/components/security.component.vue";
@Component({
  components: { ProfileSecurityComponent },
})
export default class ResetPasswordComponent extends Vue {
  token = this.$route.query.token;
}
